import { ComponentProps } from 'react';

import * as LabelPrimitive from '@radix-ui/react-label';
import clsx from 'clsx';

type LabelProps = ComponentProps<typeof LabelPrimitive.Root> & {
  required?: boolean;
};

function Label({ className, required, children, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={clsx(
        'inline-flex flex-wrap items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className
      )}
      {...props}
    >
      {children}
      {required && ' *'}
    </LabelPrimitive.Root>
  );
}

export { Label };
